import { Component, Input } from '@angular/core';
import { Order } from '../../../graphql/generated/generated-types';
import { DatePipe } from '@angular/common';

export enum OrderStatus {}
@Component({
  selector: 'app-order-status-block',
  standalone: true,
  imports: [DatePipe],
  templateUrl: './order-status-block.component.html',
  styleUrl: './order-status-block.component.scss',
})
export class OrderStatusBlockComponent {
  @Input() order: Order;
  @Input() showStatusDate!: boolean;
}
